// @flow
import * as React from 'react';
import HeaderHeight from 'app/common/react/components/Header/Context/Context';

type Props = {|
  children: (height: number) => React.Element<any>,
|};

const HeaderHeightConsumer = (props: Props) => (
  <HeaderHeight.Consumer>{props.children}</HeaderHeight.Consumer>
);

export default HeaderHeightConsumer;
